import React, { useEffect, useState } from "react";
import sendBtnIcon from "../../img/sendSignBtnIcon.svg";
import printIcon from "../../img/prinBlueIcont.svg";
import showMoreBlueIcon from "../../img/showMoreBlueIcon.svg";
import editIcon from "../../img/editBtnIcon.svg";
import signBtnIcon from "../../img/signIcon.svg";
import downloadIcon from "../../img/downloadIcon.svg";
import billOfLading from "../../img/bolDocumentPage1.jpeg";
import SendForSignatureModal from "./SendForSignatureModal/SendForSignatureModal";
import SuccessModal from "../ReusedComponents/SuccessModal/SuccessModal";
import ToolBarMenu from "./ToolBarMenu/ToolBarMenu";
import SubmitBugFixModal from "./SubmitBugFixModal/SubmitBugFixModal";
import AddIndossamentModal from "./AddIndossamentModal/AddIndossamentModal";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import useOnShowEditButton from "../../utils/CustomHooksStatuses/useOnShowEditButton/useOnShowEditButton";
import useOnShowSendForSignButton from "../../utils/CustomHooksStatuses/useOnShowSendForSignButton/useOnShowSendForSignButton";
import useOnChangeTextSendForSignModal from "../../utils/CustomHooksStatuses/useOnChangeTextSendForSignModal/useOnChangeTextSendForSignModal";
import { axiosPostSendToSignBol } from "../../Api/ApiBol/axiosPostSendToSignBol";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import { axiosPostSendToSignCaptainMan } from "../../Api/ApiMan/axiosPostSendToSignCaptainMan";
import useOnShowSignDocumentButton from "../../utils/CustomHooksStatuses/useOnShowSignDocumentButton/useOnShowSignDocumentButton";
import { axiosPostSendToSignCustomMan } from "../../Api/ApiMan/axiosPostSendToSignCustomMan";
import {
  usePostSignBol,
  usePostReleaseBol,
  usePostAnnulateBol,
  usePostSendToCollectBol,
  usePostConfirmAnnulateBol,
  usePostReleaseMan,
  usePostSignCustomMan,
  usePostAddIndossament,
} from "../../Api/Blockchain/axiosSign";
import useOnShowToolBarMenu from "../../utils/CustomHooksStatuses/useOnShowToolBarMenu/useOnShowToolBarMenu";
import useOnChangeToolBarMenu from "../../utils/CustomHooksStatuses/useOnChangeToolBarMenu/useOnChangeToolBarMenu";
import { axiosPostSendToCorrectBol } from "../../Api/ApiBol/axiosPostSendToCorrectBol";
import { axiosPostSendToCorrectMan } from "../../Api/ApiMan/axiosPostSendToCorrectMan";
import { axiosPostSignCaptainMan } from "../../Api/ApiMan/axiosPostSignCaptainMan";
import { axiosPostAnnulateMan } from "../../Api/ApiMan/axiosPostAnnulateMan";
import useOnShowManCorrector from "../../utils/CustomHooksStatuses/useOnShowManCorrector/useOnShowManCorrector";
import CreateDocSetManCorrectorModal from "../CreateDocSetManCorrectorModal/CreateDocSetManCorrectorModal";
import { axiosPostAddNewManCorrector } from "../../Api/ApiManCorrector/axiosPostAddNewManCorrector";
import { axiosGetCargoCaseId } from "../../Api/ApiCargoCase/axiosGetCargoCaseId";
import { axiosGetManId } from "../../Api/ApiMan/axiosGetManId";

import { AnnulateModal } from "./AnnulateModal/AnnulateModal";
import { SignatureModal } from "./SignatureModal/SignatureModal";
import useShowPrintTemplateButton from "../../utils/CustomHooks/useShowPrintTemplateButton/useShowPrintTemplateButton";

const SendForSignature = (props) => {
  const {
    selectedCargoCaseMan,
    selectedCargoCaseBol,
    onEditHandler,
    cargoCaseDocId,
    setTextMessage,
    isLinkTemplate
  } = props;

  const {
    auth,
    getRequestDataToggle,
    getIdUpdateBol,
    getIdUpdateMan,
    getIdCreateDoc,
  } = useAuth();

  const axiosPrivate = useAxiosPrivate();
  const [isModalMessage, setModalMessage] = useState("");
  const [activeToolBarMenu, setActiveToolBarMenu] = useState(false);
  const [activeModalSuccess, setActiveModalSuccess] = useState(false);
  const [activeModalAnnulate, setActiveModalAnnulate] = useState(false);
  const [activeModalSendToSign, setActiveModalSendToSign] = useState(false);
  const [activeModalDigitalSign, setActiveModalDigitalSign] = useState(false);
  const [activeModalSubmitBugFix, setActiveModalSubmitBugFix] = useState(false);
  const [activeModalManCorrector, setActiveModalManCorrector] = useState(false);
  const { isShowPrintButton } = useShowPrintTemplateButton(isLinkTemplate, auth, selectedCargoCaseMan, selectedCargoCaseBol);
  const [activeModalSendToCollect, setActiveModalSendToCollect] =
    useState(false);
  const [activeModalSendToRelease, setActiveModalSendToRelease] =
    useState(false);
  const [activeModalAddIndossament, setActiveModalAddIndossament] =
    useState(false);
  const [selectedCargoCase, setSelectedCargoCase] = useState([]);
  const [isPermissionSignBol, setPermissionSignBol] = useState(true);
  const [isSignManifestIncludeCurrentBol, setSignManifestIncludeCurrentBol] =
    useState(false);
  const { isShowManCorrector } = useOnShowManCorrector(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const [
    activeModalConfirmSignIndossament,
    setActiveModalConfirmSignIndossament,
  ] = useState(false);

  const { isShowEditBtn } = useOnShowEditButton(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const { isShowToolBarMenu } = useOnShowToolBarMenu(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const { itemsToolBarMenu } = useOnChangeToolBarMenu(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const { isShowSendForSignBtn } = useOnShowSendForSignButton(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const { isShowSignDocumentBtn } = useOnShowSignDocumentButton(
    auth,
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const { isTextForSendForSignModal } = useOnChangeTextSendForSignModal(
    selectedCargoCaseBol,
    selectedCargoCaseMan
  );
  const [isIndossamentData, setIndossamentData] = useState({});

  // Blockchain requests
  // Bol
  const postSignBol = usePostSignBol(axiosPrivate, cargoCaseDocId);
  const postSendToCollectBol = usePostSendToCollectBol(
    axiosPrivate,
    cargoCaseDocId
  );
  const postReleaseBol = usePostReleaseBol(axiosPrivate, cargoCaseDocId);
  const postAnnulateBol = usePostAnnulateBol(axiosPrivate, cargoCaseDocId);
  const postConfirmAnnulateBol = usePostConfirmAnnulateBol(
    axiosPrivate,
    cargoCaseDocId
  );
  // Indaossament
  const postAddIndossament = usePostAddIndossament(
    axiosPrivate,
    cargoCaseDocId
  );
  // Man
  const postSignCustomMan = usePostSignCustomMan(axiosPrivate, cargoCaseDocId);
  const postReleaseMan = usePostReleaseMan(axiosPrivate, cargoCaseDocId);

  function onCloseModal(setActive) {
    setActive(false);
    setModalMessage("");
  }

  const onOpenModalSendForSign = () => {
    setActiveModalSendToSign(true);
  };

  const onOpenModalSignDocument = () => {
    setActiveModalDigitalSign(true);
  };

  const onOpenModalSubmitBugFix = () => {
    setActiveModalSubmitBugFix(true);
  };

  const onOpenModalAnnulate = () => {
    setActiveModalAnnulate(true);
  };

  const onOpenModalSendToCollect = () => {
    if (isSignManifestIncludeCurrentBol === false) {
      setTextMessage("The manifest that contains bol is not yet signed");
    } else {
      setActiveModalSendToCollect(true);
    }
  };

  const onOpenModalSendToRelease = () => {
    setActiveModalSendToRelease(true);
  };

  const onOpenModalIndossament = () => {
    if (isSignManifestIncludeCurrentBol === false) {
      setTextMessage("The manifest that contains bol is not yet signed");
    } else {
      setActiveModalAddIndossament(true);
    }
  };

  const onOpenModalManCorrector = () => {
    setActiveModalManCorrector(true);
  };

  const onHandleToolBarMenu = (itemToolBar) => {
    switch (itemToolBar) {
      case "Annulate":
        return onOpenModalAnnulate();
        // eslint-disable-next-line no-unreachable
        break;
      case "Confirm annulate":
        return onOpenModalSignDocument();
        break;
      case "Send to collect":
        return onOpenModalSendToCollect();
        break;
      case "Send to release":
        return onOpenModalSendToRelease();
        break;
      case "Submit to bug fixes":
        return onOpenModalSubmitBugFix();
        break;
      case "Add Indossament":
        return onOpenModalIndossament();
        break;
      default:
        return itemToolBar;
    }
  };

  const onHandleSendForSign = () => {
    if (selectedCargoCaseBol !== undefined) {
      axiosPostSendToSignBol(
        axiosPrivate,
        selectedCargoCaseBol[0]?.id,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateBol,
        setActiveModalSendToSign
      );
    } else if (
      (selectedCargoCaseMan !== undefined &&
        selectedCargoCaseMan[0]?.status === "DRAFT") ||
      (selectedCargoCaseMan !== undefined &&
        selectedCargoCaseMan[0]?.status === "TO_CORRECT")
    ) { 
      if (selectedCargoCaseMan[0]?.goods.some(el => el?.bol?.status === 'DRAFT' 
          || el?.bol?.status === 'TO_CORRECT'
          || el?.bol?.status === 'TO_SIGN')) {
        setTextMessage("The manifest contains bols that have not yet been signed.");
        setActiveModalSendToSign(false);
      } else {
        axiosPostSendToSignCaptainMan(
          axiosPrivate,
          selectedCargoCaseMan[0]?.id,
          getRequestDataToggle,
          cargoCaseDocId,
          getIdCreateDoc,
          getIdUpdateMan,
          setActiveModalSendToSign
        );
      }
    }  else if (
      selectedCargoCaseMan !== undefined &&
      selectedCargoCaseMan[0]?.status === "SIGNED_CAPTAIN"
    ) {
      axiosPostSendToSignCustomMan(
        axiosPrivate,
        selectedCargoCaseMan[0]?.id,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateMan,
        setActiveModalSendToSign,
        setTextMessage
      );
    } else {
      setActiveModalSendToSign(false);
    }
  };

  const onHandleSignDocument = (body) => {
    if (
      body !== "" &&
      selectedCargoCaseBol !== undefined &&
      selectedCargoCaseBol[0]?.status === "TO_SIGN"
    ) {
      postSignBol(
        { body, id: selectedCargoCaseBol[0]?.id },
        {
          onSuccess: () => {
            setModalMessage("Successfully signed!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (error) => {
            console.log(error);
            setTextMessage("Document signing error! Try again!");
          },
          onFinally: () => {
            setActiveModalDigitalSign(false);
          },
        }
      );
    } else if (
      body !== "" &&
      selectedCargoCaseBol !== undefined &&
      selectedCargoCaseBol[0]?.status === "WAIT_CANCEL"
    ) {
      postConfirmAnnulateBol(
        { id: selectedCargoCaseBol[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successfully signed!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            console.error(err);
            setTextMessage("Document signing error! Try again!");
          },
          onFinally: () => setActiveModalDigitalSign(false),
        }
      );
    } else if (
      body !== "" &&
      selectedCargoCaseMan !== undefined &&
      selectedCargoCaseMan[0]?.status === "TO_SIGN_CAPTAIN"
    ) {
      axiosPostSignCaptainMan(
        axiosPrivate,
        selectedCargoCaseMan[0]?.id,
        body,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateMan,
        setActiveModalSuccess,
        setActiveModalDigitalSign,
        setTextMessage,
        setModalMessage
      );
    } else if (
      body !== "" &&
      selectedCargoCaseMan !== undefined &&
      selectedCargoCaseMan[0]?.status === "TO_SIGN_CUSTOM"
    ) {
      postSignCustomMan(
        { id: selectedCargoCaseMan[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successfully signed!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            console.error(err);
            setTextMessage("Document signing error! Try again!");
          },
          onFinally: () => setActiveModalDigitalSign(false),
        }
      );
    } else {
      setModalMessage("Signature required!");
    }
  };

  const onHandleReturnDocForCorrection = (body) => {
    if (body !== "" && selectedCargoCaseBol !== undefined) {
      axiosPostSendToCorrectBol(
        axiosPrivate,
        selectedCargoCaseBol[0]?.id,
        body,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateBol,
        setActiveModalSuccess,
        setActiveModalSubmitBugFix,
        setTextMessage,
        setModalMessage
      );
    } else if (body !== "" && selectedCargoCaseMan !== undefined) {
      axiosPostSendToCorrectMan(
        axiosPrivate,
        selectedCargoCaseMan[0]?.id,
        body,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateMan,
        setActiveModalSuccess,
        setActiveModalSubmitBugFix,
        setTextMessage,
        setModalMessage
      );
    } else {
      setModalMessage("You need to describe the problem!");
    }
  };

  const onHandleAnnulateDoc = (description, key) => {
    let body = {
      description: description,
      sign: key,
    };
    if (
      description !== "" &&
      key !== "" &&
      selectedCargoCaseBol !== undefined
    ) {
      postAnnulateBol(
        { id: selectedCargoCaseBol[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successful document cancellation!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            console.error(err);
            setTextMessage("Document invalidation error! Try again!");
          },
          onFinally: () => setActiveModalAnnulate(false),
        }
      );
    } else if (
      description !== "" &&
      key !== "" &&
      selectedCargoCaseMan !== undefined
    ) {
      axiosPostAnnulateMan(
        axiosPrivate,
        selectedCargoCaseMan[0]?.id,
        body,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateMan,
        setActiveModalSuccess,
        setActiveModalAnnulate,
        setTextMessage,
        setModalMessage
      );
    } else {
      setModalMessage("All fields are required!");
    }
  };

  const onHandleSendToCollect = (body) => {
    if (body !== "" && selectedCargoCaseBol !== undefined) {
      postSendToCollectBol(
        { id: selectedCargoCaseBol[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successfully sent!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (error) => {
            console.error(error);
            setTextMessage("Document invalidation error! Try again!");
          },
          onFinally: () => setActiveModalSendToCollect(false),
        }
      );
    } else {
      setModalMessage("Signature required!");
    }
  };

  const onHandleSendToRelease = (body) => {
    if (body !== "" && selectedCargoCaseBol !== undefined) {
      postReleaseBol(
        { id: selectedCargoCaseBol[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successfully sent!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            console.error(err);
            setTextMessage("Document invalidation error! Try again!");
          },
          onFinally: () => setActiveModalSendToRelease(false),
        }
      );
    } else if (body !== "" && selectedCargoCaseMan !== undefined) {
      postReleaseMan(
        { id: selectedCargoCaseMan[0]?.id, body },
        {
          onSuccess: () => {
            setModalMessage("Successfully sent!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            if (err?.response?.data?.includes("is not released or cancelled")) {
              setTextMessage(
                "Error sending to release, bills of lading included in the manifest must be implemented or canceled!"
              );
            } else {
              console.error(err);
              setTextMessage("Document invalidation error! Try again!");
            }
          },
          onFinally: () => setActiveModalSendToRelease(false),
        }
      );
    } else {
      setModalMessage("Signature required!");
    }
  };

  const onHandleConfirmSelectedIndossament = (isEndoser, isEndossat) => {
    if (isEndoser === null || isEndossat === null) {
      setModalMessage("Мust be selected endoser and endossat");
    } else if (isEndoser === isEndossat) {
      setModalMessage("Endoser and Endossat not be equal");
    } else if (isEndoser !== selectedCargoCaseBol[0]?.owner?.id) {
      setModalMessage("Your organization are not owner BOL");
    } else {
      setModalMessage("");
      setIndossamentData({
        ...isIndossamentData,
        bol_id: selectedCargoCaseBol[0]?.id,
        indossant_id: isEndoser,
        indossat_id: isEndossat,
      });
      setActiveModalConfirmSignIndossament(true);
      setActiveModalAddIndossament(false);
    }
  };

  const onHandleAddIndossament = (sign) => {
    if (sign !== "") {
      postAddIndossament(
        { indossamentData: isIndossamentData, sign },
        {
          onSuccess: () => {
            setModalMessage("Indossament successfully added!");
            setTextMessage("");
            setActiveModalSuccess(true);
          },
          onError: (err) => {
            console.error(err);
            setTextMessage("Document signing error! Try again!");
          },
          onFinally: () => setActiveModalConfirmSignIndossament(false),
        }
      );
    } else {
      setModalMessage("Signature required!");
    }
  };

  const onHandleAddManCorrector = (dataManCorrector, selectedBols) => {
    const { selectBols, ...bodyRequest } = dataManCorrector;
    const newManCorrector = { ...bodyRequest, bols: selectedBols };
    const checkingEmptyString = (element) => element === "";
    const getCargoDescNowReads = newManCorrector.bols.map(
      (el) => el.cargoDescriptionNowReads
    );
    const getCargoDescShouldRead = newManCorrector.bols.map(
      (el) => el.cargoDescriptionShouldRead
    );
    const allowConditionCargoDescNowReads =
      getCargoDescNowReads.some(checkingEmptyString);
    const allowConditionCargoDescShouldRead =
      getCargoDescShouldRead.some(checkingEmptyString);

    if (newManCorrector.bols.length === 0 || allowConditionCargoDescNowReads === true || allowConditionCargoDescShouldRead === true) {
      setModalMessage(
        "You must select a bill of lading from the table and fill in the fields!"
      );
    } else {
      axiosPostAddNewManCorrector(
        axiosPrivate,
        selectedCargoCaseMan[0]?.id,
        newManCorrector,
        getRequestDataToggle,
        cargoCaseDocId,
        getIdCreateDoc,
        getIdUpdateMan,
        setActiveModalManCorrector,
        setTextMessage,
        setModalMessage
      );
    }
  };

  function showDocument(e) {
    e.preventDefault();
    window.open(billOfLading);
  }

  const downloadDocument = () => {
    fetch(billOfLading).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = billOfLading;
        alink.click();
      });
    });
  };

  function searchStatusMan(itemsMan) {
    const statusMan = itemsMan.find(
      (el) =>
        el.status === "TO_CORRECT" ||
        el.status === "DRAFT" ||
        el.status === "TO_SIGN_CAPTAIN" ||
        el.status === "SIGNED_CAPTAIN" ||
        el.status === "TO_SIGN_CUSTOM"
    );
    if (statusMan !== undefined) {
      setSignManifestIncludeCurrentBol(false);
    } else {
      setSignManifestIncludeCurrentBol(true);
    }
  }

  function searchManIncludeCurrentBol(bolId, manList) {
    if (bolId !== 0 && manList.length !== 0) {
      const findElem = [];
      manList.forEach((item) => {
        item.goods.forEach((el) => {
          if (el.bol.id === bolId) {
            findElem.push(item);
          }
        });
      });
      searchStatusMan(findElem);
    }
  }

  function getManifests() {
    const promisesMan = selectedCargoCase[0]?.manifests.map(async (el) => {
      return await axiosGetManId(axiosPrivate, el.id);
    });
    Promise.all(promisesMan).then((data) => {
      searchManIncludeCurrentBol(selectedCargoCaseBol[0]?.id, data);
    });
  }

  useEffect(() => {
    let isLoading = true;

    if (selectedCargoCaseBol !== undefined) {
      axiosGetCargoCaseId(
        axiosPrivate,
        cargoCaseDocId,
        isLoading,
        setSelectedCargoCase
      );
    }
    return () => {
      isLoading = false;
    };
  }, [selectedCargoCaseBol]);

  useEffect(() => {
    if (selectedCargoCase.length !== 0 && selectedCargoCaseBol !== undefined) {
      getManifests();
    }
  }, [selectedCargoCase, selectedCargoCaseBol]);

  function onPostPrint() {
    window.print();
  }

  return (
    <div className="send-for-signature__container">
      {isShowEditBtn && (
        <div onClick={onEditHandler} className="send-for-signature-edit-btn">
          <img
            src={editIcon}
            className="send-for-signature__icon"
            alt={"иконка"}
          />
          <p>Edit</p>
        </div>
      )}
      {isShowManCorrector && (
        <div
          onClick={() => onOpenModalManCorrector()}
          className="create-man-corrector-btn"
        >
          <img
            src={editIcon}
            className="send-for-signature__icon"
            alt={"иконка"}
          />
          <p>Create man-corrector</p>
        </div>
      )}
      {isShowSendForSignBtn && (
        <div
          onClick={() => onOpenModalSendForSign()}
          className="send-for-signature-send-btn"
        >
          <img
            src={sendBtnIcon}
            className="send-for-signature__icon"
            alt={"иконка"}
          />
          <p>Send for signature</p>
        </div>
      )}
      {isShowSignDocumentBtn && (
        <div
          onClick={() => onOpenModalSignDocument()}
          className="send-for-signature-send-btn"
        >
          <img
            src={signBtnIcon}
            className="send-for-signature__icon"
            alt={"иконка"}
          />
          <p>Sign a document</p>
        </div>
      )}
      {/*<div className="send-for-signature-download-btn">*/}
      {/*    <img onClick={downloadDocument} src={downloadIcon} className="send-for-signature__icon" alt={'иконка'}/>*/}
      {/*</div>*/}
      {isShowPrintButton && <a href={isLinkTemplate?.fileDownloadUri} className="send-for-signature-print-btn">
        <img
          src={printIcon}
          className="send-for-signature__icon"
          alt={"иконка"}
        />
      </a>}
      {isShowToolBarMenu && (
        <div
          onClick={() => setActiveToolBarMenu(!activeToolBarMenu)}
          className="send-for-signature-show-more-btn"
        >
          <img
            src={showMoreBlueIcon}
            className="send-for-signature__icon"
            alt={"иконка"}
          />
          {activeToolBarMenu && (
            <ToolBarMenu
              itemsToolBarMenu={itemsToolBarMenu}
              onHandleToolBarMenu={onHandleToolBarMenu}
            />
          )}
        </div>
      )}
      {activeModalSendToSign && (
        <SendForSignatureModal
          onCloseModal={() => onCloseModal(setActiveModalSendToSign)}
          onHandleSendForSign={onHandleSendForSign}
          isTextForSendForSignModal={isTextForSendForSignModal}
        />
      )}
      {activeModalSuccess && (
        <SuccessModal
          onCloseModal={() => onCloseModal(setActiveModalSuccess)}
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalDigitalSign && (
        <SignatureModal
          description="Signature"
          onCloseModal={() => onCloseModal(setActiveModalDigitalSign)}
          onSend={onHandleSignDocument}
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalSubmitBugFix && (
        <SubmitBugFixModal
          onCloseModal={() => onCloseModal(setActiveModalSubmitBugFix)}
          onHandleReturnDocForCorrection={onHandleReturnDocForCorrection}
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalAddIndossament && (
        <AddIndossamentModal
          onCloseModal={() => onCloseModal(setActiveModalAddIndossament)}
          onHandleConfirmSelectedIndossament={
            onHandleConfirmSelectedIndossament
          }
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalConfirmSignIndossament && (
        <SignatureModal
          description="Confirm signature"
          onCloseModal={() =>
            onCloseModal(setActiveModalConfirmSignIndossament)
          }
          onSend={onHandleAddIndossament}
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalAnnulate && (
        <AnnulateModal
          onCloseModal={() => onCloseModal(setActiveModalAnnulate)}
          onSend={onHandleAnnulateDoc}
          isModalMessage={isModalMessage}
        />
      )}
      {activeModalSendToCollect && (
        <SignatureModal
          description="Send to collect"
          onCloseModal={() => onCloseModal(setActiveModalSendToCollect)}
          isModalMessage={isModalMessage}
          onSend={onHandleSendToCollect}
        />
      )}
      {activeModalSendToRelease && (
        <SignatureModal
          description="Send to release"
          onCloseModal={() => onCloseModal(setActiveModalSendToRelease)}
          isModalMessage={isModalMessage}
          onSend={onHandleSendToRelease}
        />
      )}
      {activeModalManCorrector && (
        <CreateDocSetManCorrectorModal
          onClose={() => onCloseModal(setActiveModalManCorrector)}
          onHandleAddManCorrector={onHandleAddManCorrector}
          selectedCargoCaseMan={selectedCargoCaseMan}
          cargoCaseDocId={cargoCaseDocId}
          isModalMessageManCorrector={isModalMessage}
        />
      )}
    </div>
  );
};
export default SendForSignature;
